export default "/images/performance.png?d8b684e3b4e7ab3f66f910046df90041";